import { AbstractControl, ValidatorFn } from "@angular/forms";
import moment from "moment";

export function dateValidator(): ValidatorFn {
    return (control: AbstractControl) => {
        const value = control.value;

        // If no value, consider it invalid
        if (!value) return null;

        // Handle string input
        if (typeof value === 'string') {
            const regex = /^(1[0-2]|0[1-9])\/(3[01]|[12][0-9]|0[1-9])\/[0-9]{4}$/;

            // Perform regex validation
            if (!regex.test(value)) {
                return { invalidDate: true }; // Invalid format
            }

            // Parse the date string
            const [month, day, year] = value.split('/').map(Number);
            const date = new Date(year, month - 1, day);

            return validateDateObject(date);
        }

        // Handle Date object or other valid input
        if (value instanceof Date && !isNaN(value.getTime())) {
            return validateDateObject(value);
        }

        // If value is a Moment object, validate directly
        if (moment.isMoment(value)) {
            if (!value.isValid()) {
                return { invalidDate: true }; // Invalid Moment date
            }

            // Custom validity checks
            const minDate = moment('1900-01-01');
            if (value.isBefore(minDate)) {
                return { invalidDate: true }; // Out of range
            }

            return null; // Valid date
        }

        // If value is neither a valid string nor a valid Date object, it's invalid
        return { invalidDate: true };
    };
}

// Helper function to validate a Date object
function validateDateObject(date: Date) {

    const minDate = new Date(1900, 0, 1); // January 1, 1900

    if (date < minDate) {
        return { invalidDate: true }; // Out of range
    }


    return null; // Valid date
}
